import { type IInfoGroup } from '@inpart-io/padme-iap';
import { type MutationTree } from 'vuex';

import { type InfoGroupsResult } from './types';

export const RECEIVE_INFO_GROUPS = 'receiveInfoGroups';

export const mutations: MutationTree<InfoGroupsResult> = {
    [RECEIVE_INFO_GROUPS](_state, { infoGroups }: { infoGroups: IInfoGroup[] }) {
        infoGroups.forEach((infoGroup: IInfoGroup) => {
            _state.allInfoGroups.set(infoGroup.infogroupType, infoGroup);
        });
    }
};
